import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);

const asArray = (value) => Array.isArray(value) ? value : [];
const CAMPAIGN_ROUTE_FALLBACKS = { "diwali-2026": "/diwali" };
const DEFAULT_EVENT_CAMPAIGNS = [
  { key: "navratri-2026", label: "Navratri 2026", active: true, route: "/navratri", description: "Garba, Dandiya and Raas events." },
  { key: "diwali-2026", label: "Diwali 2026", active: true, route: "/diwali", description: "Diwali events and community celebrations." },
  { key: "bollywood-nights", label: "Bollywood Nights", active: true, route: "/bollywood", description: "Bollywood DJ nights, boat parties and club events." },
];
const activeCampaigns = (value) => asArray(value)
  .filter((item) => item && item.active !== false && item.key && item.label)
  .map((item) => ({ ...item, route: item.route || CAMPAIGN_ROUTE_FALLBACKS[item.key] || "" }));

export const AppProvider = ({ children }) => {
  const [city, setCity] = useState(() => localStorage.getItem("nn_city") || "London");
  const [language, setLanguage] = useState(() => localStorage.getItem("nn_language") || "All");
  const [category, setCategory] = useState("All");
  const [cities, setCities] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [campaigns, setCampaigns] = useState(DEFAULT_EVENT_CAMPAIGNS);

  useEffect(() => { localStorage.setItem("nn_city", city); }, [city]);
  useEffect(() => { localStorage.setItem("nn_language", language); }, [language]);

  useEffect(() => {
    (async () => {
      try {
        const [c, l, cat, campaignRes] = await Promise.all([
          api.get("/cities"),
          api.get("/languages"),
          api.get("/categories"),
          api.get("/app-options/event_campaigns"),
        ]);
        setCities(asArray(c.data));
        setLanguages(asArray(l.data));
        setCategories(asArray(cat.data));
        setCampaigns(activeCampaigns(campaignRes.data?.value));
      } catch (e) { /* noop */ }
    })();
  }, []);

  return (
    <AppContext.Provider value={{ city, setCity, language, setLanguage, category, setCategory, cities, languages, categories, campaigns }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
